import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const MoveSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default MoveSVG;
